import React from "react";
import { useState } from "react";
import Image from "next/image";
import Thumbnail from "public/assets/akademi/akademi-thumb.jpg";
import { VideoModal } from "components/video-modal/video-modal";
import {
  AboutWrapper,
  AboutContainer,
  AboutTextContainer,
  AboutText,
  AboutVideoThumbContainer,
  AboutCTA,
  AboutTitle,
  AboutDesc,
  VdoThumbnail,
  PlayButtonContainer
} from "./akademi-about.styles";

export const AkademiAbout: React.FC = () => {
  const videoUrl = "https://www.youtube.com/watch?v=wh6NQysUdGo";
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);

  const handleClick = () => {
    setIsVideoPlaying(true);
  };

  return (
    <AboutWrapper>
      <AboutContainer>
        <AboutTextContainer>
          <AboutText>
            <AboutTitle>Tentang Akademi Guru Juara</AboutTitle>
            <AboutDesc>
              Program pengembangan untuk menciptakan guru-guru profesional yang
              berperan dalam membangun pemahaman Matematika ribuan murid di
              seluruh Indonesia.
            </AboutDesc>
            <AboutCTA rel="nofollow" href="/gurujuara">
              Siapa Guru Juara CoLearn?
            </AboutCTA>
          </AboutText>
        </AboutTextContainer>
        <AboutVideoThumbContainer onClick={handleClick}>
          <VdoThumbnail>
            <Image
              src={Thumbnail}
              alt="Akademi Guru Juara"
              layout="responsive"
            />
          </VdoThumbnail>
          <PlayButtonContainer />
        </AboutVideoThumbContainer>
        {isVideoPlaying && (
          <VideoModal
            onClose={() => setIsVideoPlaying(false)}
            videoUrl={videoUrl}
          />
        )}
      </AboutContainer>
    </AboutWrapper>
  );
};
